import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  originatorLocationProductsList: [],
  pending: false,
};

const reducers = {
  fetchOriginatorLocationProductsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchOriginatorLocationProductsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchOriginatorLocationProductsSuccess(state, { payload }) {
    return R.assoc('originatorLocationProductsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originatorLocationProducts',
  reducers,
});

const {
  fetchOriginatorLocationProductsPending,
  fetchOriginatorLocationProductsSuccess,
  fetchOriginatorLocationProductsError,
} = actions;

// Selectors
const originatorLocationProductsListSelector = state =>
  state.pto.originatorLocationProducts.originatorLocationProductsList;

export const originatorLocationProductOptionsSelector = createSelector(
  originatorLocationProductsListSelector,
  products =>
    products.map(({ productId, productNameLong }) => ({
      label: productNameLong,
      value: productId,
    }))
);

// Actions
let fetchController;
export function fetchOriginatorLocationProducts(params = {}) {
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  return dispatch => {
    dispatch(fetchOriginatorLocationProductsPending(true));
    const formattedParams = qs.stringify(params, {
      allowDots: true,
      encode: false,
    });

    return http
      .get(`/product-transfer-orders/get-unique-originator-location-products?${formattedParams}`, {
        signal,
      })
      .then(({ data }) => {
        dispatch(fetchOriginatorLocationProductsError(''));
        dispatch(fetchOriginatorLocationProductsSuccess(data));
        dispatch(fetchOriginatorLocationProductsPending(false));
      })
      .catch(error => {
        if (error?.response?.data?.title) {
          dispatch(
            createSnack({
              message: error.response.data.title,
              options: { variant: 'error' },
            })
          );
        }
      });
  };
}

export default reducer;
